<template>
    <div class="input-group">
        <input v-model="numberValueRaw" type="text" class="form-control"
               :class="{'is-invalid': isInvalid()}">
        <div class="input-group-text" v-if="unit !== null">{{ unit }}</div>
        <div v-if="isInvalid()" class="invalid-feedback d-block">
            <template v-if="numberValueRaw === ''">{{ $t('form.errors.parameterNotFilled', [label]) }}</template>
            <template v-else-if="isNaN(getValue())">{{ $t('form.errors.notANumber') }}</template>
            <template v-else-if="getValue() < min">{{ $t('form.errors.mustBeLargerThan', [label, min]) }}</template>
        </div>
    </div>
</template>

<script lang="ts">
import {Control} from '@/composables/Control';
import {defineComponent, PropType, ref, watch} from 'vue';

export default defineComponent({
    props: {
        value: {
            type: Number as PropType<number | null>,
            default: null,
        },
        validate: {
            type: Boolean,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        min: {
            type: Number as PropType<number | null>,
            required: true,
        },
        unit: {
            type: String as PropType<string | null>,
            default: null,
        },
    },
    emits: ['input', 'validated'],
    setup(props, {emit}) {
        const numberValueRaw = ref('');

        function getValue(): number | null {
            if (numberValueRaw.value === '') {
                return null;
            }

            if (! /^[0-9]+$/.test(numberValueRaw.value)) {
                return NaN;
            }

            return Number.parseInt(numberValueRaw.value, 10);
        }

        function validateCurrentValue(): boolean {
            const value = getValue();

            return value === null || (! isNaN(value) && (props.min === null || value >= props.min));
        }

        const {updateValue, isInvalid} = Control<number>(props, emit, {
            getValue,
            validateCurrentValue,
        });

        watch(numberValueRaw, () => {
            updateValue();
        });

        // created logic
        if (props.value !== null) {
            numberValueRaw.value = '' + props.value;
        }

        return {
            numberValueRaw,
            getValue,
            isInvalid,
        };
    },
});
</script>
